import { useCallback, useState } from 'react';
import { isEmpty } from 'lodash';

export const useEntityFormIndications = () => {
    const [indications, setIndications] = useState({});

    const addToIndications = useCallback(
        (indicationType, entityId) => {
            setIndications(prevIndications => {
                const existingIndicationValue = prevIndications[indicationType];
                const updatedEntityIdsOfType = isEmpty(existingIndicationValue)
                    ? [entityId]
                    : [...existingIndicationValue, entityId];

                return { ...prevIndications, [indicationType]: updatedEntityIdsOfType };
            });
        },
        [setIndications]
    );

    return { indications, setIndications, addToIndications };
};
